import { type SVGProps } from "react";

export function JiffyLogoTransfersLab(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="22"
      viewBox="0 0 38 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.0546 4.08722L27.4949 5.30997C27.984 6.66706 29.0527 7.73574 30.4098 8.22484L31.6325 8.66514C31.7427 8.70516 31.7427 8.86144 31.6325 8.90091L30.4098 9.34121C29.0527 9.83032 27.984 10.899 27.4949 12.2561L27.0546 13.4789C27.0146 13.5891 26.8583 13.5891 26.8188 13.4789L26.3785 12.2561C25.8894 10.899 24.8208 9.83032 23.4637 9.34121L22.2409 8.90091C22.1307 8.86089 22.1307 8.70462 22.2409 8.66514L23.4637 8.22484C24.8208 7.73574 25.8894 6.66706 26.3785 5.30997L26.8188 4.08722C26.8583 3.97646 27.0146 3.97646 27.0546 4.08722Z"
        fill="#DA2FD5"
      />
      <path
        d="M32.5618 1.14893L32.785 1.76798C33.0328 2.45502 33.574 2.99621 34.2611 3.24405L34.8801 3.46722C34.936 3.48751 34.936 3.56646 34.8801 3.58675L34.2611 3.80992C33.574 4.05776 33.0328 4.59895 32.785 5.28599L32.5618 5.90504C32.5415 5.96097 32.4626 5.96097 32.4423 5.90504L32.2191 5.28599C31.9713 4.59895 31.4301 4.05776 30.743 3.80992L30.124 3.58675C30.0681 3.56646 30.0681 3.48751 30.124 3.46722L30.743 3.24405C31.4301 2.99621 31.9713 2.45502 32.2191 1.76798L32.4423 1.14893C32.4626 1.09245 32.5421 1.09245 32.5618 1.14893Z"
        fill="#DA2FD5"
      />
      <path
        d="M32.5618 11.6618L32.785 12.2809C33.0328 12.9679 33.574 13.5091 34.2611 13.7569L34.8801 13.9801C34.936 14.0004 34.936 14.0793 34.8801 14.0996L34.2611 14.3228C33.574 14.5706 33.0328 15.1118 32.785 15.7989L32.5618 16.4179C32.5415 16.4739 32.4626 16.4739 32.4423 16.4179L32.2191 15.7989C31.9713 15.1118 31.4301 14.5706 30.743 14.3228L30.124 14.0996C30.0681 14.0793 30.0681 14.0004 30.124 13.9801L30.743 13.7569C31.4301 13.5091 31.9713 12.9679 32.2191 12.2809L32.4423 11.6618C32.4626 11.6059 32.5421 11.6059 32.5618 11.6618Z"
        fill="#DA2FD5"
      />
      <path
        d="M17.0419 18.8343C16.7894 20.0125 16.3939 20.9383 15.8552 21.6115C15.3335 22.3016 14.7191 22.8234 14.0122 23.1769C13.3052 23.5304 12.5478 23.7576 11.7399 23.8586C10.9151 23.9596 10.0904 24.0101 9.26562 24.0101L9.56859 22.268C9.82107 22.268 10.0567 22.2427 10.2755 22.1922C10.4775 22.1417 10.6627 22.0323 10.831 21.864C10.9993 21.6957 11.1592 21.4432 11.3107 21.1066C11.4453 20.7868 11.5716 20.3407 11.6894 19.7685L13.9869 8.912H19.1627L17.0419 18.8343ZM19.7686 5.60457C19.7686 5.9917 19.6845 6.32833 19.5161 6.61447C19.3647 6.90061 19.1543 7.14467 18.8849 7.34665C18.6325 7.54863 18.3379 7.70012 18.0013 7.80111C17.6646 7.9021 17.3196 7.95259 16.9661 7.95259C16.2929 7.95259 15.729 7.79269 15.2745 7.47289C14.8201 7.15309 14.5929 6.64813 14.5929 5.95803C14.5929 5.58774 14.6686 5.25952 14.8201 4.97338C14.9716 4.67041 15.1736 4.42635 15.426 4.2412C15.6953 4.03922 15.9983 3.88773 16.3349 3.78674C16.6884 3.68575 17.0503 3.63525 17.4206 3.63525C18.077 3.63525 18.6325 3.79516 19.0869 4.11496C19.5414 4.43476 19.7686 4.9313 19.7686 5.60457Z"
        fill="url(#paint0_linear_10675_14936)"
      />
      <path
        d="M10.3173 8.96289H6.61127C5.97165 8.96289 5.45312 9.48141 5.45312 10.121C5.45312 10.7607 5.97165 11.2792 6.61127 11.2792H10.3173C10.957 11.2792 11.4755 10.7607 11.4755 10.121C11.4755 9.48141 10.957 8.96289 10.3173 8.96289Z"
        fill="url(#paint1_linear_10675_14936)"
      />
      <path
        d="M8.23097 17.3014H3.83003C3.1904 17.3014 2.67188 17.8199 2.67188 18.4595C2.67188 19.0992 3.1904 19.6177 3.83003 19.6177H8.23097C8.8706 19.6177 9.38913 19.0992 9.38913 18.4595C9.38913 17.8199 8.8706 17.3014 8.23097 17.3014Z"
        fill="url(#paint2_linear_10675_14936)"
      />
      <path
        d="M9.39059 13.1321H1.97846C1.33883 13.1321 0.820312 13.6506 0.820312 14.2902C0.820312 14.9299 1.33883 15.4484 1.97846 15.4484H9.39059C10.0302 15.4484 10.5487 14.9299 10.5487 14.2902C10.5487 13.6506 10.0302 13.1321 9.39059 13.1321Z"
        fill="url(#paint3_linear_10675_14936)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10675_14936"
          x1="21.7373"
          y1="5.01001"
          x2="8.08186"
          y2="16.0507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F421CF" />
          <stop offset="0.490385" stopColor="#7764EA" />
          <stop offset="1" stopColor="#5DB9FE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10675_14936"
          x1="12.6043"
          y1="9.11918"
          x2="11.8699"
          y2="12.1143"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F421CF" />
          <stop offset="0.490385" stopColor="#7764EA" />
          <stop offset="1" stopColor="#5DB9FE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10675_14936"
          x1="10.6482"
          y1="17.4577"
          x2="9.98233"
          y2="20.4865"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F421CF" />
          <stop offset="0.490385" stopColor="#7764EA" />
          <stop offset="1" stopColor="#5DB9FE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10675_14936"
          x1="12.3722"
          y1="13.2884"
          x2="11.9011"
          y2="16.3921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F421CF" />
          <stop offset="0.490385" stopColor="#7764EA" />
          <stop offset="1" stopColor="#5DB9FE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
